import {toAbsoluteUrl} from "../routes/Routes";
import axios from "axios";

export async function getAction (auth_token) {
  return axios({
    method: 'get',
    url: toAbsoluteUrl(`/api/readAction`),
    headers: {'authorization': `Bearer ${auth_token}`}
  });
}

export async function getAgency (auth_token) {
  return axios({
    method: 'get',
    url: toAbsoluteUrl(`/api/readAgency`),
    headers: {'authorization': `Bearer ${auth_token}`}
  });
}
export async function getCarrier (auth_token) {
  return axios({
    method: 'get',
    url: toAbsoluteUrl(`/api/readCarrier`),
    headers: {'authorization': `Bearer ${auth_token}`}
  });
}
export async function getDestinationFacility (auth_token) {
  return axios({
    method: 'get',
    url: toAbsoluteUrl(`/api/readDestinationFacility`),
    headers: {'authorization': `Bearer ${auth_token}`}
  });
}

export async function getPrompt (auth_token) {
  return axios({
    method: 'get',
    url: toAbsoluteUrl(`/api/readPrompt`),
    headers: {'authorization': `Bearer ${auth_token}`}
  });
}
